import Nullstack from 'nullstack';
export default function IconSunHigh({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-sun-high",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M14.828 14.828a4 4 0 1 0 -5.656 -5.656a4 4 0 0 0 5.656 5.656z"
  }), "   ", Nullstack.element("path", {
    d: "M6.343 17.657l-1.414 1.414"
  }), "   ", Nullstack.element("path", {
    d: "M6.343 6.343l-1.414 -1.414"
  }), "   ", Nullstack.element("path", {
    d: "M17.657 6.343l1.414 -1.414"
  }), "   ", Nullstack.element("path", {
    d: "M17.657 17.657l1.414 1.414"
  }), "   ", Nullstack.element("path", {
    d: "M4 12h-2"
  }), "   ", Nullstack.element("path", {
    d: "M12 4v-2"
  }), "   ", Nullstack.element("path", {
    d: "M20 12h2"
  }), "   ", Nullstack.element("path", {
    d: "M12 20v2"
  }), " ");
}